export const enum LogisticStatus {
  ARRIVED = "Arrived",
  NOT_ARRIVED = "Not Arrived",
  OUT = "Out",
  BROKEN = "Broken",
  WEAR = "Wear",
  //!Deprecati
  //// BACKUP = "Backup",
  //// UNSET = "Unset",
}

/**
 * * Oggetto chiave valore per reperire i valori numerici da passare al BE in fase di aggiornamento degli stati.
 * * Poteve usare semplicemente un enumm come quello sopra assegnando direttamente i valori numerici
 * *    ma per i seguenti motivi non è stato fatto:
 * * Gli stati impattano un po' ovunque nell'app quindi ho preferito fare un intervento puntuale;
 * * Il BE in GET mi torna la stringa dello stato di logistica, in POST/PUT vuole il valore numerico,
 * *    quindi avrei dovuto implementare nuove logiche di conversione degli stati;
 * * Avrei dovuto implementare anche una nuova logica di traduzione.
 */
export const LOGISTIC_STATUS_VALUES = {
  [LogisticStatus.ARRIVED]: 0,
  [LogisticStatus.NOT_ARRIVED]: 1,
  [LogisticStatus.OUT]: 2,
  [LogisticStatus.BROKEN]: 3,
  [LogisticStatus.WEAR]: 4,
  //!Deprecati
  //// [LogisticStatus.BACKUP]: 5,
  //// [LogisticStatus.UNSET]: 6,
}

/**
 * * Questo dizionario definisce, a partire da uno stato, tutti gli stati a cui un prodotto
 * * può passare.
 * * Esempio:
 * *    ho un prodotto nello stato BROKEN, può passare solo allo stato ARRIVED o OUT
 * *    ho un prodotto nello stato NOT_ARRIVED, può passare solo allo stato ARRIVED
 */
// export const LOGISTIC_STATUS_DICTIONARY: { [key: string]: LogisticStatus[] } = {
export const LOGISTIC_STATUS_DICTIONARY: Map<LogisticStatus, LogisticStatus[]> = new Map([
  [LogisticStatus.NOT_ARRIVED, [LogisticStatus.ARRIVED]],
  [LogisticStatus.ARRIVED, [LogisticStatus.OUT, LogisticStatus.WEAR, LogisticStatus.BROKEN]],
  //!Deprecato stato BACKUP
  //// [LogisticStatus.ARRIVED, [LogisticStatus.OUT, LogisticStatus.BACKUP, LogisticStatus.WEAR, LogisticStatus.BROKEN]],
  [LogisticStatus.OUT, [LogisticStatus.ARRIVED]],
  //!Deprecato stato BACKUP
  //// [LogisticStatus.BACKUP, [LogisticStatus.ARRIVED, LogisticStatus.WEAR, LogisticStatus.BROKEN, LogisticStatus.OUT]],
  [LogisticStatus.BROKEN, [LogisticStatus.ARRIVED, LogisticStatus.OUT]],
  [LogisticStatus.WEAR, [LogisticStatus.ARRIVED]]
]);
